import React, { Component } from 'react';
import {setEffectsChainToShow} from "actions/index.js";
import { connect } from "react-redux";
import ConditionedComponent from 'components/ConditionedComponent.js';

function EffectsChainChooser(props) {

    function chooseEffectsChain(i) {
        props.setEffectsChainToShow(
            props.track.subSequence.id,
            props.track.trackNumber,
            i);
    }

    function newEffectsChain() {
        props.track.newEffectsChain();
    }

    function deleteEffectsChain() {
        props.track.deleteEffectsChain();
    }

    if (props.track === undefined) {
        return (
            <div></div>
        );
    }
    let effectsChains = props.track.effectsChains;
    return (
        <div className="effects-chain-chooser">
          {effectsChains.map(
              (chain, i) =>
                  <div
                        onClick={() => chooseEffectsChain(i)}
                        className={props.chainNumber === i ? "effects-chain-btn selected" : "effects-chain-btn"}>
                        {i + 1}
                  </div>)}
            <div
              className="new-effects-chain-btn"
              onClick={() => newEffectsChain()}>
              +
            </div>
            <ConditionedComponent condition={props.track && props.track.effectsChains.length > 1}>
            <div
        className="new-effects-chain-btn"
        onClick={() => deleteEffectsChain()}>-</div>
            </ConditionedComponent>
            </div>
                  
    );
}

const mapStateToProps = (state, props) => {
    let chainNumber = 0;
    if (props.track) {
        chainNumber = props.track.chainNumber;
    }
    return {
        chainNumber: chainNumber,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setEffectsChainToShow:  (subSequenceId, trackNumber, fxChain) => dispatch(setEffectsChainToShow(
            subSequenceId, trackNumber, fxChain)),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(EffectsChainChooser);
